import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Placeholder, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import trainer from 'assets/img/team/5-thumb.png';
import FalconCardHeader from 'components/common/FalconCardHeader';
import IconButton from 'components/common/IconButton';
import FalconLink from 'components/common/FalconLink';
import SoftBadge from 'components/common/SoftBadge';
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
/* import useCompany from 'components/modules/company/useCompany'; */
import useUser from 'components/modules/users/useUser';

const tags = [
 {
  id: 0,
  text: 4.95,
  icon: 'star',
  class: 'rounded-pill border py-2 px-3'
 },
 {
  id: 1,
  text: 35400,
  icon: 'graduation-cap',
  class: 'rounded-pill border py-2 px-3'
 },
 {
  id: 2,
  text: 15,
  icon: 'file-alt',
  class: 'rounded-pill border py-2 px-3'
 },
 {
  id: 3,
  text: 5700,
  icon: 'map-pin',
  class: 'rounded-pill border py-2 px-3'
 }
];

const Placehold = () => (
 <Card className="overflow-hidden mb-3">
  <Card.Header variant="top" className="p-0">
   <span className="placeholder w-100" />
  </Card.Header>
  <Card.Body>
   <Placeholder as={Card.Title} animation="glow" className="mb-2">
    <Avatar size="4xl" name="?" isExact />
    <Placeholder xs={4} />
   </Placeholder>
   <Placeholder as={Card.Text} animation="glow">
    <Placeholder xs={7} className="me-3" />
    <Placeholder xs={4} />
    <Placeholder xs={4} className="me-3" />
    <Placeholder xs={6} />
    <Placeholder xs={8} />
   </Placeholder>
   <Placeholder.Button variant="primary" xs={3} className="float-end" />
  </Card.Body>
 </Card>
);

const ProjectUser = ({ user }) => {
 const { data } = useUser(user);
 return data ? (
  <Card className="mb-3">
   <FalconCardHeader
    title="Agente"
    titleTag="h5"
    endEl={
     <IconButton variant="falcon-primary" size="sm" icon="user-plus" iconClassName="ms-1">
      Seguir
     </IconButton>
    }
   />
   <Card.Body className="bg-light">
    <Row className="g-4 text-center text-md-start">
     <Col md="auto">
      <Avatar size="4xl" src={data?.avatar || trainer} />
     </Col>
     <Col>
      <h5 className="mb-2">
       <Link to="/e-learning/trainer-profile">{data?.fullName}</Link>
      </h5>
      <h6 className="fs--1 text-800 fw-normal mb-3">{data?.profession}</h6>
      <p className="fs--1 text-700">{data?.description[0]}</p>
      <Flex wrap="wrap" justifyContent="center" className="gap-2 justify-content-md-start">
       {tags.map(tag => (
        <SoftBadge key={tag.id} pill bg="light" className="border border-300 text-secondary py-2 px-3">
         <FontAwesomeIcon icon={tag.icon} className="me-2" />
         {tag.text}
        </SoftBadge>
       ))}
      </Flex>
     </Col>
    </Row>
   </Card.Body>
   <Card.Footer className="text-end py-2">
    <FalconLink title="Ir a ver perfil" to={`/user/profile/${user}`} icon="external-link-alt" className="fw-medium" />
   </Card.Footer>
  </Card>
 ) : (
  <Placehold />
 );
};

const ProjectCompany = ({ business }) => {
 //  business = business._id ? business : useCompany(business)?.data;
 return business?._id ? (
  <Card className="mb-3">
   <FalconCardHeader
    title="Empresa"
    titleTag="h5"
    endEl={
     <IconButton variant="falcon-primary" size="sm" icon="user-plus" iconClassName="ms-1">
      Seguir
     </IconButton>
    }
   />
   <Card.Body className="bg-light">
    <Row className="g-4 text-center text-md-start">
     <Col md="auto">
      <Avatar size="4xl" src={business?.logo || trainer} />
     </Col>
     <Col>
      <h5 className="mb-2">
       <Link to="/e-learning/trainer-profile">{business?.alias}</Link>
      </h5>
      <h6 className="fs--1 text-800 fw-normal mb-3">Company | Business</h6>
      <p className="fs--1 text-700">{business?.description}</p>
      <Flex wrap="wrap" justifyContent="center" className="gap-2 justify-content-md-start">
       {tags.map(tag => (
        <SoftBadge key={tag.id} pill bg="light" className="border border-300 text-secondary py-2 px-3">
         <FontAwesomeIcon icon={tag.icon} className="me-2" />
         {tag.text}
        </SoftBadge>
       ))}
      </Flex>
     </Col>
    </Row>
   </Card.Body>
   <Card.Footer className="text-end py-2">
    <FalconLink title="Ir a ver perfil" to={`/company/profile/${business?._id}`} icon="external-link-alt" className="fw-medium" />
   </Card.Footer>
  </Card>
 ) : (
  <Placehold />
 );
};

const ProjectProponent = ({ company, user }) => {
 console.log('company business user', company, user);
 if (user) return <ProjectUser user={user} />;
 else return <ProjectCompany business={company} />;
};

ProjectUser.propTypes = { user: PropTypes.string };

ProjectCompany.propTypes = { business: PropTypes.string };

ProjectProponent.propTypes = { company: PropTypes.string, user: PropTypes.string };

export default ProjectProponent;
